import React from 'react';
import './footer.scss';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <footer className="footer-container">
      <div className="left-align"></div>

      <div className="center-align">
        <p>&copy; {new Date().getFullYear()} Carmella Setiabudi</p>
      </div>

      <div className="right-align social-icons">
        <a
          href="https://github.com/cmell05"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub profile"
        >
          <FaGithub />
        </a>
        <a
          href="https://www.linkedin.com/in/carmellasetiabudi"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn profile"
        >
          <FaLinkedin />
        </a>
        <a
          href="mailto:carmella0502@gmail.com"
          aria-label="Email"
        >
          <FaEnvelope />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
